import { Link } from "react-router-dom";

export const BankingFuture = () => (
  <section className="section dark" id="future">
    <div className="section-inner">
      <span className="section-eyebrow">Where banking is going</span>
      <h2>Banking is going conversational.</h2>
      <p className="lede">
        Today, banking happens in your bank's app. Soon, it will happen wherever your
        customers already spend their time: inside Claude, ChatGPT, and the next wave
        of AI tools. The banks that win are the ones whose data, products, and
        operations show up in those tools natively, with bank-grade controls.
      </p>

      <div className="future-grid">
        <div className="future-card">
          <div className="future-card-when">Today</div>
          <h3>For individuals: AI inside your bank's app.</h3>
          <p>
            The first step for retail customers is an AI assistant inside the bank's
            existing digital channel. Customers ask about their balance, set up a
            transfer, review last month's spending, or get help understanding a fee, all
            in natural language. The bank keeps the experience, the brand, and the
            relationship.
          </p>
          <p className="future-card-product">
            Powered by{" "}
            <Link to="/assistant" className="btn-arrow">Bancony Assistant</Link>
          </p>
        </div>

        <div className="future-card">
          <div className="future-card-when">Near future</div>
          <h3>For corporates: banking from inside the AI they already use.</h3>
          <p>
            A finance team running cash-flow analysis in Claude or ChatGPT will soon
            want to pull live balances, reconcile transactions, and authorise payments
            without leaving the AI tool. Bancony Server makes the bank's capabilities
            available to those AI clients through the open bank2ai (MCP) standard, with
            the bank's controls fully intact.
          </p>
          <p className="future-card-product">
            Powered by{" "}
            <Link to="/server" className="btn-arrow">Bancony Server</Link>
          </p>
        </div>
      </div>

      <p className="future-footer">
        Either way, the bank stays at the centre. Your customers' data, your identity,
        your controls. We just make sure it works wherever the conversation happens.
      </p>
    </div>
  </section>
);
